/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AdminSingleSectionData } from '@INTERFACES/admin-api/sections';

export interface SectionNameModalState {
    isOpen: boolean;

    data: {
        sectionData: AdminSingleSectionData;
    } | null;
}

export interface SectionNameModalDispatchParams {
    sectionData: AdminSingleSectionData;
}

const initialState: SectionNameModalState = {
    isOpen: false,
    data: null,
};

export const sectionNameModalSlice = createSlice({
    name: 'section-name-modal',
    initialState,
    reducers: {
        open(state: SectionNameModalState, action: PayloadAction<SectionNameModalDispatchParams>) {
            state.isOpen = true;
            state.data = action.payload;
        },
        close(state: SectionNameModalState) {
            state.isOpen = false;
            state.data = null;
        },
    },
});
